import { type SelectOption } from '@/shared/ui/select';

const optionsToIds = (sites: SelectOption[]) =>
  sites.map((site) => site.value as number);

export default optionsToIds;
